<div class="plc-text-input__wrapper" [class]="wrapperClass">
	@if (icon) {
		<plc-icon
			[name]="icon"
			[hover]="true"
			(click)="emitIconClick()"
		></plc-icon>
	}
	<label
		class="plc-text-input__wrapper__label"
		[class]="labelClass"
		(click)="forceFocus()"
	>
		{{ label }}
	</label>
	<input
		#input
		[class]="inputClass"
		[name]="name"
		[autocomplete]="autocomplete"
		[type]="type"
		[placeholder]="placeholder"
		[value]="value"
		(input)="handleInput($event.target.value)"
		(focus)="handleFocus(true)"
		(blur)="handleBlur()"
	/>

	<plc-icon
		class="plc-text-input__wrapper__icon"
		*ngIf="passwordIcon"
		[name]="passwordIcon"
		[hover]="true"
		(click)="togglePassword()"
	/>
</div>

<plc-validation-messages
	[viewMode]="viewMode"
	[validations]="validations"
	[errors]="errors"
/>
